import React from 'react';
import { connect } from 'react-redux';

import { getVacancyShareDetails } from '../redux/modules/user/action';
import { SERVER_BASE_URL } from '../constants';

class VacancyShare extends React.Component {
  state = {
    message: null
  };

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(getVacancyShareDetails(match.params.id));
  }

  render() {
    const { shareVacancyDetails = { userDetail: {} } } = this.props;
    if (!shareVacancyDetails) {
      return (
        <React.Fragment>
          <header className="menu_logo back">
          <div className="left_logo">
            <img alt="" src="/images/logo.png" />
          </div>
          <div className="right_logo">
          </div>
        </header>
        <div className="container">
        <section className="menu_list">
          <h3>No Details Found</h3>
        </section>
        </div>
        </React.Fragment>
      );
    }

    const name = `${shareVacancyDetails.userDetail.firstName} ${shareVacancyDetails.userDetail.lastName}`;
    const address = shareVacancyDetails.address;
    const leaseTerm = shareVacancyDetails.leaseTerm ? `${Math.round(shareVacancyDetails.leaseTerm / 30)} Month Lease` : '';
    const image = shareVacancyDetails.propertyImages.length > 0 ? shareVacancyDetails.propertyImages[0].image : '';

    const fullAddress = `${shareVacancyDetails.city} ${shareVacancyDetails.state} ${shareVacancyDetails.country}`;
    const profileImage = shareVacancyDetails.userDetail.image || '';
    
    return (
      <React.Fragment>
        <header className="menu_logo back">
          <div className="left_logo">
            <img alt="" src="/images/logo.png" />
          </div>
          <div className="right_logo">
            <img alt="" src={`${SERVER_BASE_URL}${profileImage}`} />
            <h3>{name}<br /></h3>
          </div>
        </header>
        <div className="container">
          <section className="menu_list">
            <div className="list_40 ">
              <div className="profiles ">
                <h3>{address}</h3>
                <img alt="" src={`${SERVER_BASE_URL}${image}`} />
              </div>
            </div>
            <div className="list_60 ">
              <div className="profiles ">
                <h3>{shareVacancyDetails.title}</h3>
                <ul>
                  <li><img alt="" src="https://image.flaticon.com/icons/svg/259/259973.svg" /> {shareVacancyDetails.bathrooms} Bathrooms</li>
                  <li><img alt="" src="https://image.flaticon.com/icons/svg/1577/1577505.svg" /> {shareVacancyDetails.bedrooms} Bedrooms</li>
                  {
                    shareVacancyDetails.isPet ? 
                    <li>
                      <img alt="" src="https://image.flaticon.com/icons/svg/1530/1530720.svg" /> 
                      Pet Friendly
                    </li> : ''
                  }
                  {
                    shareVacancyDetails.property_type ? 
                    <li><img alt="" src="https://image.flaticon.com/icons/svg/63/63272.svg" /> {shareVacancyDetails.property_type}</li> : ''
                  }
                </ul>
                <iframe
                  src={`https://www.google.com/maps/embed/v1/place?q=${address}%5C&key=AIzaSyDaGklOl7yE8NrqwYgy2_1JWGjsp3loEZE`}
                  width="600"
                  height="250"
                  frameborder="0"
                  style={{ border: 0 }}
                  allowfullscreen
                ></iframe>

                <h4> Price:<b> ${shareVacancyDetails.maxRentAmount}</b> </h4>
                <h5>{leaseTerm}</h5>
              </div>
            </div>

          </section>
          <section className="menu_play">
            <a href="https://itunes.apple.com/us/app/roomerresume/id1392857337?ls=1&mt=8"><img alt="" src="/images/apple.png" /></a>
            <a href="https://play.google.com/store/apps/details?id=com.roomer_resume" style={{ marginLeft: '10px' }}>
            <img alt="" src="/images/play.png" />  </a>
          </section>
        </div>
        <footer className="menu_logo back">
          <div className="foter">
            <p> Copyright 2019 © RoomerResume. All Rights Reserved.</p>
          </div>
        </footer>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  shareVacancyDetails: state.user.shareVacancyDetails
});

export default connect(mapStateToProps)(VacancyShare);